export default __webpack_public_path__ + "static/user5-71b34247d44bca01691ad9df0168c77c.jpeg";